const NAMESPACE = 'jbp-plan-section-dialog'

export const PLAN_SECTION_DIALOG_TRANSLATION_KEYS = {
  close: `${NAMESPACE}--close`, // Close
  editMode: 'core-edit-mode', // Edit mode
  // In place of the section while Overall, which lacks it, is picked over it.
  overallTitle: `${NAMESPACE}--overall-title`, // This section is not part of Overall
  // Available params: {section}.
  overallHint: `${NAMESPACE}--overall-hint`, // Pick an offering above to open its {section}.
}
